'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppWrapper;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const googleAnalytics = typeof window !== 'undefined' ? window.ga : undefined;
function AppWrapper(props) {
  let pathname = document.location.pathname;
  (0, _react.useEffect)(() => {
    if (document.location.pathname !== pathname) {
      console.log('page change detected');
      pathname = document.location.pathname;
      window.scrollTo(0, 0);
      if (typeof googleAnalytics === 'function') {
        googleAnalytics('set', 'page', props.location.pathname);
        googleAnalytics('send', 'pageview');
      }
    }
  }, [document.location.pathname]);
  const routes = (0, _reactRouterDom.useRoutes)(props.routes);
  return routes;
}
